'use client'
import {useTranslations} from 'next-intl';
import {useRouter} from 'next/navigation';

export default function ErrorPrimary({errors, status}) {
  const t = useTranslations('error');
  const router = useRouter();
  
  const reloadPage = () => {
    router.refresh();
  }
  
  return (
    <div className="ltn__404-area ltn__404-area-1">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="error-404-inner text-center">
              <h1 className="error-404-subtitle">{status}</h1>
              <h2>{t('title')}</h2>
              <p>{
                Array.isArray(errors) && errors?.length > 0
                    ? errors.map(e => t.has(`message.${e}`) ? t(`message.${e}`) : e).join()
                    : t.has(`message.${errors}`) ? t(`message.${errors}`) : errors
              }</p>
              <div className="btn-wrapper">
                <button onClick={reloadPage} className="btn btn-transparent">
                  <i className="fas fa-rotate-right"></i> {t('reload').toUpperCase()}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
